// DBT-157 — riconosce la risposta «nome già presente» del backend.
//
// Il backend risponde 409 con un corpo strutturato (`backend/apps/core/nomi_univoci.py`):
//   { codice: 'nome_gia_presente', tipo, campo, nome, esistente_id, titolo, testo, detail }
// Titolo e testo arrivano già composti dal CMS di AIstotele: il frontend li
// MOSTRA, non li riscrive. I testi qui sotto sono solo la rete se il corpo
// arriva senza: il messaggio non deve mai ridursi al JSON grezzo (Regola 14).
//
// ⚠️ Anche «Apri cantiere» da preventivo usa il 409 (per «cantiere già aperto»):
// si distingue dal `codice`, mai dallo stato soltanto.

export const CODICE_NOME_GIA_PRESENTE = 'nome_gia_presente';

export const TIPI_NOME_UNIVOCO = ['cliente', 'fornitore', 'cantiere'];

export const TITOLO_DEFAULT = 'Nome già presente';

export function testoDefault(tipo, nome) {
  return 'Esiste già un ' + tipo + ' con il nome «' + nome + '». Per evitare '
    + 'sovrapposizioni nella gestione di documenti, preventivi e fatture, ti '
    + 'chiediamo di modificare il nome in modo che sia univoco, ad esempio '
    + "aggiungendo la città, l'indirizzo o un riferimento distintivo.";
}

function testoPieno(v) {
  return typeof v === 'string' && v.trim() !== '';
}

// Ritorna { tipo, campo, nome, esistenteId, titolo, testo } se l'errore è
// «nome già presente», altrimenti null.
export function nomeGiaPresenteDaErrore(err) {
  var resp = err && err.response;
  if (!resp || resp.status !== 409) return null;
  var data = resp.data;
  if (!data || typeof data !== 'object' || data.codice !== CODICE_NOME_GIA_PRESENTE) return null;
  var tipo = TIPI_NOME_UNIVOCO.indexOf(data.tipo) >= 0 ? data.tipo : 'cliente';
  var nome = testoPieno(data.nome) ? data.nome : '';
  return {
    tipo: tipo,
    campo: data.campo === 'titolo' ? 'titolo' : 'nome',
    nome: nome,
    esistenteId: testoPieno(data.esistente_id) ? data.esistente_id : null,
    titolo: testoPieno(data.titolo) ? data.titolo : TITOLO_DEFAULT,
    testo: testoPieno(data.testo) ? data.testo : testoDefault(tipo, nome),
  };
}

// Dove si apre il record già presente.
export function rottaEsistente(tipo, id) {
  if (!id) return null;
  if (tipo === 'cantiere') return '/cantieri/' + id;
  if (tipo === 'fornitore') return '/fornitori?apri=' + id;
  return '/clienti?apri=' + id;
}

// Il campo nome dei moduli porta `data-campo-nome`: «Modifica il nome» lo
// seleziona, e i dati già inseriti restano dove sono (il modulo non si chiude).
export const ATTRIBUTO_CAMPO_NOME = 'data-campo-nome';

export function selezionaCampoNome(doc) {
  var d = doc || (typeof document !== 'undefined' ? document : null);
  if (!d) return false;
  var campi = d.querySelectorAll('[' + ATTRIBUTO_CAMPO_NOME + ']');
  var campo = campi.length ? campi[campi.length - 1] : null;
  if (!campo) return false;
  campo.focus();
  if (typeof campo.select === 'function') campo.select();
  return true;
}

// Stessa regola del backend (`normalizza_nome`): minuscole, niente spazi ai
// bordi, spazi interni singoli. Serve a RICONOSCERE un record già presente
// (es. il fornitore letto da un PDF), non a riscrivere un nome.
export function normalizzaNome(nome) {
  return String(nome == null ? '' : nome).trim().split(/\s+/).join(' ').toLowerCase();
}

export function stessoNome(a, b) {
  var na = normalizzaNome(a);
  return na !== '' && na === normalizzaNome(b);
}
